import { render, staticRenderFns } from "./GeneratedLicences.vue?vue&type=template&id=50a8c25a&scoped=true"
import script from "./GeneratedLicences.vue?vue&type=script&lang=js"
export * from "./GeneratedLicences.vue?vue&type=script&lang=js"
import style0 from "./GeneratedLicences.vue?vue&type=style&index=0&id=50a8c25a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a8c25a",
  null
  
)

export default component.exports